import { Role } from '@core/referential/role.enum'
import { UseCase } from '@core/referential/use-case.enum'
import { z } from 'zod'

import { mailSchema } from '@shared/schema/mail.schema'

export const GetUserQueryStringSchema = z
  .object({
    roles: z
      .string()
      .transform((value) => value.split(','))
      .refine((value) => value?.every((v) => Object.values(Role).includes(v)))
      .optional()
      .default(''),
  })
  .optional()

export const GetUserSchemaResponse = z.array(
  z.object({
    id: z.string().uuid(),
    firstname: z.string(),
    lastname: z.string(),
    phone: z.string().optional().nullable(),
    mail: mailSchema,
    role: z.nativeEnum(Role),
    useCases: z.array(z.nativeEnum(UseCase)),
  }),
)

export type GetUserResponse = z.infer<typeof GetUserSchemaResponse>
export type GetUserQueryString = z.infer<typeof GetUserQueryStringSchema>
